/** Verrouillage scroll (modales) — sans position:fixed pour éviter tout saut de page. */

const SCROLL_LOCK_ATTR = 'data-scroll-lock';
const SCROLL_LOCK_PADDING_SELECTOR = '[data-scroll-lock-padding]';

let lockCount = 0;

type SavedStyles = {
  htmlOverflow: string;
  htmlOverscroll: string;
  bodyOverflow: string;
  paddedElements: { el: HTMLElement; paddingRight: string }[];
};

let saved: SavedStyles | null = null;

function getScrollbarWidth(): number {
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

function applyScrollbarPadding(width: number): { el: HTMLElement; paddingRight: string }[] {
  if (width <= 0) return [];
  const padded: { el: HTMLElement; paddingRight: string }[] = [];
  const body = document.body;
  padded.push({ el: body, paddingRight: body.style.paddingRight });
  body.style.paddingRight = `${width}px`;

  document.querySelectorAll<HTMLElement>(SCROLL_LOCK_PADDING_SELECTOR).forEach((el) => {
    padded.push({ el, paddingRight: el.style.paddingRight });
    el.style.paddingRight = `${width}px`;
  });

  return padded;
}

/** À appeler quand isOpen passe à true ; le cleanup déverrouille. */
export function acquireBodyScrollLock(): () => void {
  if (typeof document === 'undefined') {
    return () => {};
  }

  if (lockCount === 0) {
    const root = document.documentElement;
    const body = document.body;
    const scrollbarWidth = getScrollbarWidth();

    saved = {
      htmlOverflow: root.style.overflow,
      htmlOverscroll: root.style.overscrollBehavior,
      bodyOverflow: body.style.overflow,
      paddedElements: applyScrollbarPadding(scrollbarWidth),
    };

    root.setAttribute(SCROLL_LOCK_ATTR, '1');
    root.style.overflow = 'hidden';
    root.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';
  }

  lockCount += 1;

  return () => {
    if (typeof document === 'undefined') return;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount > 0 || !saved) return;

    const root = document.documentElement;
    const body = document.body;
    const snapshot = saved;
    saved = null;

    root.removeAttribute(SCROLL_LOCK_ATTR);
    root.style.overflow = snapshot.htmlOverflow;
    root.style.overscrollBehavior = snapshot.htmlOverscroll;
    body.style.overflow = snapshot.bodyOverflow;

    snapshot.paddedElements.forEach(({ el, paddingRight }) => {
      el.style.paddingRight = paddingRight;
    });
  };
}

export function isBodyScrollLocked(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.getAttribute(SCROLL_LOCK_ATTR) === '1';
}
